import {  FiSettings,  FiEdit, FiUsers, FiArchive, FiInbox, FiBarChart, FiSend, FiMapPin } from "react-icons/fi"

export const optsTabs = [
    {symbol:<FiEdit />,title:'Edit', type:'project-create', url:'#'},
    {symbol:<FiUsers />,title:'Media', url:'#', type:'media'},
    {symbol:<FiArchive />,title:'Inbox', url:'#', type:'inbox'},
    {symbol:<FiInbox/>,title:'OutBox', url:'#', type:'outbox'},
    {symbol:<FiSettings />,title:'Settings', url:'#', type:'settings'},
     {symbol:<FiBarChart />,title:'Statistics', url:'#',type:'statistics'},
     {symbol:<FiSend />,title:'Chat', url:'#',type:'chat'},
     {symbol:<FiMapPin />,title:'Location', url:'#',type:'location'},
];

export const skillList = [
    {id:1,name:'WordPress', description:'Template and extensions.', star:4 },
    {id:2,name:'Laravel', description:'Most popular framework of php langauge and easy to use', star:3 },
];

export const profileTypes = [
    {name: '', value: ''},
];

export const langList = [
    {id:2, title:'Arabic', active:false},
    {id:1, title:'Urdu', active:false},
    {id:2, title:'Kurdish', active:false},
    {id:4, title:'English', active:false},
    {id:5, title:'Japanese', active:false},
    {id:6, title:'Chechen', active:false},
    {id:7, title:'Circassian', active:false},
    {id:8, title:'Russian', active:false},
];
